module.exports = __webpack_public_path__ + "media/images/landing/persons/anna-bartoskova-e629b86506b8391a52322f59910c72e7.jpg";